import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { LogoIcon } from '../../Other/Icons/Icons';
import Button from '../../Buttons/Button/Button';
import { useTranslation } from 'react-i18next';
import { useScroll } from '../../../context/ScrollContext';


const Footer = () => {
  // Инициализация хука перевода
  const { t, i18n } = useTranslation();
  const { scrollTo } = useScroll();

  const handleOrderClick = () => {
    console.log('Нажата кнопка заказа');
    scrollTo('requestForm');
  };
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <Link to="/" className='logo'>
            <LogoIcon color="var(--color-background)"/>
          </Link>
        </div>
        
        <div className="footer-contacts">
          <a href={`mailto:${t('header.email')}`}>{t('header.email')}</a>
        </div>
        
        <div className="info-block">
          <div className="footer-phone">
            <a href={`tel:${t('header.phoneClean')}`}>{t('header.phone')}</a>
            <p className="footer-schedule">{t('header.workingHours')}</p>
          </div>
          <div className="working-hours">
            <p className="footer-note">{t('header.weekendNote')}</p>
          </div>
        </div>
        
        
        <Button 
            text={t('header.orderButton')} 
            onClick={handleOrderClick} 
            type="primary"
            className="footer-button"
          />
      </div>
    </footer>
  );
};

export default Footer; 